/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import StateDependencyComponent from './StateDependencyComponent';
import { StateID } from './StateID';
import StateReference from './StateReference';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Class used to block a [[StateComponent]] until it's flag marked true. */
@cc._decorator.ccclass
export default class StateDependencyFlag extends StateDependencyComponent
{
    /** [[StateComponent]] to block. */
    @property({ type: StateReference, visible: true })
    private _flagOnState: StateReference = new StateReference(StateID.Initializing, true);

    /** @hidden */
    @property({ readonly: true, override: true })
    protected isBlocking: boolean = true;

    /** @hidden */
    protected start(): void
    {
        super.start([this._flagOnState]);
    }

    /** Mark flags as true for blocked [[StateComponent]]. */
    public Complete(): void
    {
        this.completeState(this._flagOnState.Value);
    }
}
